var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._b(
      {
        staticClass: "button",
        class: {
          button_animated: _vm.animation,
          button_light: _vm.light,
          button_outlined: _vm.outlined,
          button_secondary: _vm.secondary,
          button_primary: _vm.primary,
          button_small: _vm.small
        },
        on: {
          click: function($event) {
            return _vm.$emit("click", $event)
          }
        }
      },
      "button",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }